<template>
    <div id="app">
        <div class="header">
            <img class="logo" />
        </div>

        <div class="container">
            <router-view></router-view>
        </div>

        <div class="footer">
            <span>Copyright &copy; Mineverse&reg; LLC &lt;https://mineverse.com&gt; ALL RIGHTS RESERVED.</span>
        </div>
    </div>
</template>
<script>
    import "./css/app.css"
    import "./css/link.css"
    import "./css/fail.css"
import "./css/minetime.css"
import "./css/mineverse.css"
import "./css/skyblock.css"

export default {}
</script>